import { useState } from "react";
import { Anchor, Button, Group, Stack, Text } from "@mantine/core";
import { TrashIcon } from "@heroicons/react/24/solid";
import { BottomSheet } from "./BottomSheet";

export function DeletePensionData({
  onDelete,
}: {
  onDelete: () => Promise<boolean>;
}) {
  const [opened, setOpened] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [failed, setFailed] = useState(false);

  const close = () => {
    setOpened(false);
    setFailed(false);
  };

  const confirm = async () => {
    setDeleting(true);
    setFailed(false);
    const deleted = await onDelete().catch(() => false);
    setDeleting(false);
    setFailed(!deleted);
    setOpened(!deleted);
  };

  return (
    <>
      <Anchor
        component="button"
        type="button"
        fz="14px"
        c="var(--wallet-color-masterbrand-brand-burgundy)"
        onClick={() => setOpened(true)}
      >
        <Group component="span" gap="xs" wrap="nowrap" mb="6px">
          <TrashIcon width={16} height={16} />
          Ta bort pensionsuppgifter
        </Group>
      </Anchor>

      <BottomSheet
        opened={opened}
        onClose={close}
        title={
          failed ? "Något gick fel" : "Vill du ta bort alla pensionsuppgifter?"
        }
      >
        <Stack gap="md">
          {failed ? (
            // A changed sheet title is not announced, so this is the live region.
            <Text size="sm" lh={1.6} role="alert">
              Pensionsuppgifterna kunde inte tas bort just nu och finns kvar i
              översikten. Försök igen om en stund.
            </Text>
          ) : (
            <Text size="sm" lh={1.6}>
              Uppgifterna tas bort från din pensionsöversikt. Dina pensioner
              påverkas inte och du kan alltid hämta uppgifterna igen senare.
            </Text>
          )}
          <Button fullWidth loading={deleting} onClick={confirm}>
            {failed ? "Försök igen" : "Ta bort"}
          </Button>
          <Button
            fullWidth
            variant="default"
            disabled={deleting}
            onClick={close}
          >
            Avbryt
          </Button>
        </Stack>
      </BottomSheet>
    </>
  );
}
